import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { class_type, option_type, bool_type, int32_type, record_type, array_type, uint8_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";

export class S3UploadFile extends Record {
    constructor(FileName, MimeType, Payload) {
        super();
        this.FileName = FileName;
        this.MimeType = MimeType;
        this.Payload = Payload;
    }
}

export function S3UploadFile_$reflection() {
    return record_type("Shared.SharedModels.S3UploadFile", [], S3UploadFile, () => [["FileName", string_type], ["MimeType", string_type], ["Payload", array_type(uint8_type)]]);
}

export class Task extends Record {
    constructor(Id, Name, Description, VerificationRequired) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Description = Description;
        this.VerificationRequired = VerificationRequired;
    }
}

export function Task_$reflection() {
    return record_type("Shared.SharedModels.Task", [], Task, () => [["Id", int32_type], ["Name", string_type], ["Description", string_type], ["VerificationRequired", bool_type]]);
}

export class NewTask extends Record {
    constructor(Name, Description, VerificationRequired) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.VerificationRequired = VerificationRequired;
    }
}

export function NewTask_$reflection() {
    return record_type("Shared.SharedModels.NewTask", [], NewTask, () => [["Name", string_type], ["Description", string_type], ["VerificationRequired", bool_type]]);
}

export class UpdatedTask extends Record {
    constructor(Name, Description, VerificationRequired) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.VerificationRequired = VerificationRequired;
    }
}

export function UpdatedTask_$reflection() {
    return record_type("Shared.SharedModels.UpdatedTask", [], UpdatedTask, () => [["Name", string_type], ["Description", string_type], ["VerificationRequired", bool_type]]);
}

export class NewCourse extends Record {
    constructor(Name, Summary, Description, Tasks, Image) {
        super();
        this.Name = Name;
        this.Summary = Summary;
        this.Description = Description;
        this.Tasks = Tasks;
        this.Image = Image;
    }
}

export function NewCourse_$reflection() {
    return record_type("Shared.SharedModels.NewCourse", [], NewCourse, () => [["Name", string_type], ["Summary", string_type], ["Description", string_type], ["Tasks", array_type(NewTask_$reflection())], ["Image", option_type(S3UploadFile_$reflection())]]);
}

export class Course extends Record {
    constructor(Id, Name, Summary, Description, ImageUrl, Inserted, Tasks) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Summary = Summary;
        this.Description = Description;
        this.ImageUrl = ImageUrl;
        this.Inserted = Inserted;
        this.Tasks = Tasks;
    }
}

export function Course_$reflection() {
    return record_type("Shared.SharedModels.Course", [], Course, () => [["Id", int32_type], ["Name", string_type], ["Summary", string_type], ["Description", option_type(string_type)], ["ImageUrl", option_type(string_type)], ["Inserted", class_type("System.DateTime")], ["Tasks", array_type(Task_$reflection())]]);
}

export class UpdateCourse extends Record {
    constructor(Course, ImagePayLoad) {
        super();
        this.Course = Course;
        this.ImagePayLoad = ImagePayLoad;
    }
}

export function UpdateCourse_$reflection() {
    return record_type("Shared.SharedModels.UpdateCourse", [], UpdateCourse, () => [["Course", Course_$reflection()], ["ImagePayLoad", option_type(S3UploadFile_$reflection())]]);
}

export class TrackLevelCourse extends Record {
    constructor(Id, TrackLevelId, Course, Order, Inserted) {
        super();
        this.Id = (Id | 0);
        this.TrackLevelId = (TrackLevelId | 0);
        this.Course = Course;
        this.Order = (Order | 0);
        this.Inserted = Inserted;
    }
}

export function TrackLevelCourse_$reflection() {
    return record_type("Shared.SharedModels.TrackLevelCourse", [], TrackLevelCourse, () => [["Id", int32_type], ["TrackLevelId", int32_type], ["Course", Course_$reflection()], ["Order", int32_type], ["Inserted", class_type("System.DateTime")]]);
}

export class TrackLevel extends Record {
    constructor(Id, Name, Description, TrackId, Order, Inserted, TrackLevelCourses, Tasks, RequiredTasks) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Description = Description;
        this.TrackId = (TrackId | 0);
        this.Order = (Order | 0);
        this.Inserted = Inserted;
        this.TrackLevelCourses = TrackLevelCourses;
        this.Tasks = Tasks;
        this.RequiredTasks = RequiredTasks;
    }
}

export function TrackLevel_$reflection() {
    return record_type("Shared.SharedModels.TrackLevel", [], TrackLevel, () => [["Id", int32_type], ["Name", string_type], ["Description", string_type], ["TrackId", int32_type], ["Order", int32_type], ["Inserted", class_type("System.DateTime")], ["TrackLevelCourses", array_type(TrackLevelCourse_$reflection())], ["Tasks", array_type(Task_$reflection())], ["RequiredTasks", array_type(Task_$reflection())]]);
}

export class NewTrack extends Record {
    constructor(Name, Description, ImagePayload) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.ImagePayload = ImagePayload;
    }
}

export function NewTrack_$reflection() {
    return record_type("Shared.SharedModels.NewTrack", [], NewTrack, () => [["Name", string_type], ["Description", string_type], ["ImagePayload", option_type(S3UploadFile_$reflection())]]);
}

export class Track extends Record {
    constructor(Id, Name, Description, Enabled, ImageUrl, Inserted, TrackLevels) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.ImageUrl = ImageUrl;
        this.Inserted = Inserted;
        this.TrackLevels = TrackLevels;
    }
}

export function Track_$reflection() {
    return record_type("Shared.SharedModels.Track", [], Track, () => [["Id", int32_type], ["Name", string_type], ["Description", string_type], ["Enabled", bool_type], ["ImageUrl", option_type(string_type)], ["Inserted", class_type("System.DateTime")], ["TrackLevels", array_type(TrackLevel_$reflection())]]);
}

export class Region extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function Region_$reflection() {
    return record_type("Shared.SharedModels.Region", [], Region, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class NewRegion extends Record {
    constructor(Name, Enabled) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function NewRegion_$reflection() {
    return record_type("Shared.SharedModels.NewRegion", [], NewRegion, () => [["Name", string_type], ["Enabled", bool_type]]);
}

export class Workplace extends Record {
    constructor(Id, Name, Enabled, Region) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.Region = Region;
    }
}

export function Workplace_$reflection() {
    return record_type("Shared.SharedModels.Workplace", [], Workplace, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type], ["Region", Region_$reflection()]]);
}

export class NewWorkplace extends Record {
    constructor(Name, Enabled, RegionId) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.RegionId = (RegionId | 0);
    }
}

export function NewWorkplace_$reflection() {
    return record_type("Shared.SharedModels.NewWorkplace", [], NewWorkplace, () => [["Name", string_type], ["Enabled", bool_type], ["RegionId", int32_type]]);
}

export class UpdatedWorkplace extends Record {
    constructor(Id, Name, Enabled, RegionId) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.RegionId = (RegionId | 0);
    }
}

export function UpdatedWorkplace_$reflection() {
    return record_type("Shared.SharedModels.UpdatedWorkplace", [], UpdatedWorkplace, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type], ["RegionId", int32_type]]);
}

export class User extends Record {
    constructor(Id, KeycloakId, FirstName, LastName, Enabled, IsAdmin, ImageUrl, Workplace, Inserted) {
        super();
        this.Id = (Id | 0);
        this.KeycloakId = KeycloakId;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Enabled = Enabled;
        this.IsAdmin = IsAdmin;
        this.ImageUrl = ImageUrl;
        this.Workplace = Workplace;
        this.Inserted = Inserted;
    }
}

export function User_$reflection() {
    return record_type("Shared.SharedModels.User", [], User, () => [["Id", int32_type], ["KeycloakId", class_type("System.Guid")], ["FirstName", string_type], ["LastName", string_type], ["Enabled", bool_type], ["IsAdmin", bool_type], ["ImageUrl", option_type(string_type)], ["Workplace", option_type(Workplace_$reflection())], ["Inserted", class_type("System.DateTime")]]);
}

export class UpdatedUser extends Record {
    constructor(FirstName, LastName, Enabled, IsAdmin, WorkplaceId) {
        super();
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Enabled = Enabled;
        this.IsAdmin = IsAdmin;
        this.WorkplaceId = WorkplaceId;
    }
}

export function UpdatedUser_$reflection() {
    return record_type("Shared.SharedModels.UpdatedUser", [], UpdatedUser, () => [["FirstName", string_type], ["LastName", string_type], ["Enabled", bool_type], ["IsAdmin", bool_type], ["WorkplaceId", option_type(int32_type)]]);
}

export class Event$ extends Record {
    constructor(Id, Name, Enabled, Summary, Description, Address, MaxAttendees, AttendeeCount, Time, Course, Teacher, Region) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.AttendeeCount = (AttendeeCount | 0);
        this.Time = Time;
        this.Course = Course;
        this.Teacher = Teacher;
        this.Region = Region;
    }
}

export function Event$_$reflection() {
    return record_type("Shared.SharedModels.Event", [], Event$, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", string_type], ["MaxAttendees", int32_type], ["AttendeeCount", int32_type], ["Time", class_type("System.DateTime")], ["Course", Course_$reflection()], ["Teacher", User_$reflection()], ["Region", Region_$reflection()]]);
}

export class NewEvent extends Record {
    constructor(Name, Enabled, Summary, Description, Address, MaxAttendees, Time, TeacherId, CourseId, RegionId) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.Time = Time;
        this.TeacherId = (TeacherId | 0);
        this.CourseId = (CourseId | 0);
        this.RegionId = (RegionId | 0);
    }
}

export function NewEvent_$reflection() {
    return record_type("Shared.SharedModels.NewEvent", [], NewEvent, () => [["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", string_type], ["MaxAttendees", int32_type], ["Time", class_type("System.DateTime")], ["TeacherId", int32_type], ["CourseId", int32_type], ["RegionId", int32_type]]);
}

export class UpdatedEvent extends Record {
    constructor(Name, Enabled, Summary, Description, Address, MaxAttendees, Time, TeacherId) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.Time = Time;
        this.TeacherId = (TeacherId | 0);
    }
}

export function UpdatedEvent_$reflection() {
    return record_type("Shared.SharedModels.UpdatedEvent", [], UpdatedEvent, () => [["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", string_type], ["MaxAttendees", int32_type], ["Time", class_type("System.DateTime")], ["TeacherId", int32_type]]);
}

export class EventAttendee extends Record {
    constructor(User, CompletedTasks, TimeSignedUp) {
        super();
        this.User = User;
        this.CompletedTasks = CompletedTasks;
        this.TimeSignedUp = TimeSignedUp;
    }
}

export function EventAttendee_$reflection() {
    return record_type("Shared.SharedModels.EventAttendee", [], EventAttendee, () => [["User", User_$reflection()], ["CompletedTasks", array_type(Task_$reflection())], ["TimeSignedUp", class_type("System.DateTime")]]);
}

export class Session extends Record {
    constructor(User, AppVersion) {
        super();
        this.User = User;
        this.AppVersion = AppVersion;
    }
}

export function Session_$reflection() {
    return record_type("Shared.SharedModels.Session", [], Session, () => [["User", User_$reflection()], ["AppVersion", option_type(string_type)]]);
}

export class AuditLogChange extends Record {
    constructor(Field, OldValue, NewValue) {
        super();
        this.Field = Field;
        this.OldValue = OldValue;
        this.NewValue = NewValue;
    }
}

export function AuditLogChange_$reflection() {
    return record_type("Shared.SharedModels.AuditLogChange", [], AuditLogChange, () => [["Field", string_type], ["OldValue", option_type(string_type)], ["NewValue", option_type(string_type)]]);
}

export class AuditLog extends Record {
    constructor(DateTime, Action, User, Changes, TableName) {
        super();
        this.DateTime = DateTime;
        this.Action = (Action | 0);
        this.User = User;
        this.Changes = Changes;
        this.TableName = TableName;
    }
}

export function AuditLog_$reflection() {
    return record_type("Shared.SharedModels.AuditLog", [], AuditLog, () => [["DateTime", class_type("System.DateTime")], ["Action", int32_type], ["User", option_type(string_type)], ["Changes", array_type(AuditLogChange_$reflection())], ["TableName", string_type]]);
}

//# sourceMappingURL=SharedModels.jsx.map
